import axios from 'axios'

const api = axios.create({
    baseURL:  'https://test-api.yantralive.com',
})

export default api;